export const convertAllNullPropertiesToUndefined = <T>(params: T) => {
  if (!params || typeof params !== 'object') {
    return params;
  }
  const convertedTypeParams = params as Record<string, unknown>;

  // some keys can be symbols, if we use object.entries we cannot get those keys.
  // one of recommended ways of doing it is using Reflect
  const paramKeys = Reflect.ownKeys(convertedTypeParams);
  paramKeys.forEach(key => {
    // Symbol cannot be used as index so we need to convert it to string
    if (convertedTypeParams[String(key)] === null) {
      convertedTypeParams[String(key)] = undefined;
    }
  });
  return convertedTypeParams as T;
};
